/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente Wrap
 */
export const Wrap = styled.div`
  position: relative;

  label {
    font-size: 14px;
    line-height: 14px;
    color: rgba(0, 0, 0, 0.56);
    display: block;
    margin-bottom: 8px;
    position: absolute;
    top: 12px;
    left: 12px;
    display: ${({ inputIsActive }) => (inputIsActive ? 'none' : 'block')};
  }

  input::placeholder {
    color: ${({ inputIsActive }) =>
      inputIsActive ? 'initial' : 'transparent'};
    opacity: 0.5;
  }

  input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: ${({ inputIsActive }) =>
      inputIsActive ? 'initial' : 'transparent'};
  }

  input::-ms-input-placeholder {
    /* Microsoft Edge */
    color: ${({ inputIsActive }) =>
      inputIsActive ? 'initial' : 'transparent'};
  }

  .error {
    position: absolute;
    bottom: -18px;
    color: red;
    font-size: 10px;
  }

  .MuiInputBase-input {
    height: 40px;
    border: 0.5px solid rgba(0, 0, 0, 0.56);
    border-radius: 3px;
    /*margin-bottom: 30px;*/
    padding: 10px;
    box-sizing: border-box;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
  }

  .MuiInputAdornment-positionEnd {
    position: absolute;
    right: 16px;
    top: 20px;
    .MuiTypography-root {
      font-size: 18px;
    }
  }
`;
